import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white">
            <h5 className="text-white">
              <br />
              <br />
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With your extensive background in information security governance and
                certifications like CISM and CISSP, how do you see the evolving role of governance
                frameworks in ensuring business continuity amid emerging cyber threats?
              </strong>
            </h5>

            <h5 className="text-white">
              Governance frameworks are fundamental in ensuring business continuity as cyber threats
              become more sophisticated. My experience with frameworks such as ISO 27001, NIST, and
              COBIT has demonstrated that a structured approach to security governance not only
              mitigates risks but also builds long-term resilience. A robust governance model
              ensures that cybersecurity is integrated into enterprise risk management and aligned
              with business objectives. This involves fostering accountability at all levels, from
              boardroom discussions to operational execution. Additionally, as cyber threats grow in
              complexity, governance frameworks must also address third-party risks, supply chain
              vulnerabilities, and the need for comprehensive incident response and recovery
              strategies. My focus has always been on ensuring governance frameworks enable
              proactive risk management, real-time monitoring, and adaptive security measures. This
              holistic approach allows organizations to anticipate, withstand, and recover from
              cyber disruptions, ultimately safeguarding business continuity.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-User awareness is often cited as one of the weakest links in cybersecurity. With
                your experience in implementing user awareness programs, what innovative methods
                have you found most effective in creating a security-conscious culture within
                organizations?
              </strong>
            </h5>
            <h5 className="text-white">
              User awareness is a critical component of cybersecurity, and traditional training
              alone is insufficient. A continuous, engaging approach is essential. One of the most
              effective strategies I have implemented is a role-based security awareness program,
              where employees receive tailored cybersecurity training based on their job functions
              and risk exposure. Gamification, real-time phishing simulations, and interactive
              learning modules significantly enhance engagement. Additionally, fostering a
              security-first culture requires executive buy-in and continuous reinforcement.
              integrated cybersecurity awareness into daily workflows, ensuring employees recognize
              threats in real-world scenarios. By making security a shared responsibility and
              empowering employees with practical knowledge, organizations can significantly reduce
              the risk of human error.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With an exceptional career across prestigious banks and top cybersecurity
                certifications, what has been your most defining career moment?
              </strong>
            </h5>
            <h5 className="text-white">
              There have been several defining moments in my career, but two stand out the most.
              <br />
              First, leading the establishment of a fully operational Security Operations Center
              (SOC) was a key milestone. This project involved integrating advanced threat
              intelligence, automation, and incident response capabilities to fortify cybersecurity
              defences. It not only strengthened protection against sophisticated attacks but also
              demonstrated how security can seamlessly align with business operations.
              <br />
              Second, receiving the "World CIO 200 Summit - Legends Category" award for three
              consecutive years was a great recognition of my contributions to the cybersecurity
              field. It reaffirmed the impact of my efforts in driving security innovation and
              resilience within the financial sector.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Based on your hands-on experience in implementing innovative security solutions,
                how do you evaluate and adopt emerging technologies while maintaining a balance
                between cost, operational efficiency, and security?
              </strong>
            </h5>
            <h5 className="text-white">
              Adopting emerging technologies requires a risk-based, business-aligned approach to
              ensure security, efficiency, and cost-effectiveness. the evaluation process includes:
              <br />
              Thorough Risk Assessment: Assessing potential security implications before considering
              new technologies.
              <br />
              Proof of Concept (PoC): Testing the technology in a controlled environment to evaluate
              effectiveness and compatibility with existing systems.
              <br />
              Alignment with Business Needs: Ensuring technology addresses a specific business
              challenge or enhances security posture measurably.
              <br />
              Security by Design: Embedding security controls from the outset rather than as an
              afterthought.
              <br />
              Phased Implementation: Gradually rolling out the solution to monitor performance and
              make necessary adjustments.
              <br />
              This structured approach ensures that new technologies enhance both security and
              operational resilience while maintaining financial viability.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- How do you empower your teams to take ownership of cybersecurity responsibilities
                while fostering a culture of leadership and accountability across the organization?
              </strong>
            </h5>
            <h5 className="text-white">
              Empowering teams begin with clear communication, well-defined roles, and fostering a
              sense of ownership. Cybersecurity should not be seen as an IT-exclusive function but a
              collaborative responsibility across all business units.
              <br />
              <br />
              To instill leadership and accountability, emphasize:
              <br />
              Decentralized security governance: Assigning security champions within business units
              to act as liaisons with the InfoSec team.
              <br />
              Practical training and mentorship: Providing hands-on security exercises, real-world
              simulations, and continuous skill development.
              <br />
              Cross-functional collaboration: Conducting tabletop exercises and security drills to
              ensure preparedness and response capabilities.
              <br />
              By embedding security into every function and encouraging proactive ownership,
              organizations create a culture where cybersecurity is a shared responsibility, not
              just a compliance requirement.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Today, CISOs play a vital role in aligning cybersecurity with organizational
                goals while supporting business innovation. How has your leadership philosophy
                evolved throughout your career to align security objectives with overall business
                strategies?
              </strong>
            </h5>
            <h5 className="text-white">
              My leadership philosophy is to position cybersecurity as a business enabler rather
              than a constraint. In today’s digital era, security must support innovation, customer
              trust, and regulatory compliance while minimizing risks.
              <br />
              Key principles that guide my leadership approach include:
              <br />
              Embedding security into the business strategy rather than treating it as an isolated
              function.
              <br />
              Fostering a risk-aware culture where security is considered from the early stages of
              any digital transformation.
              <br />
              Engaging with executive leadership to ensure cybersecurity investments provide
              tangible business value.
              <br />
              Security is not just about protecting assets—it’s about enabling resilient, secure,
              and sustainable business growth.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Creating a security-first culture can be challenging, especially in large
                organizations with diverse teams.What strategies have you found most effective in
                promoting cybersecurity awareness across different business departments?
              </strong>
            </h5>
            <h5 className="text-white">
              A one-size-fits-all approach doesn’t work for security awareness. Instead, I’ve found
              that a role-based security awareness framework tailored to different departments is
              most effective.
              <br />
              Some key strategies include:
              <br />
              Customized training: Secure coding practices for developers, fraud prevention for
              front-line staff, and social engineering resistance for customer service teams.
              <br />
              Integration into daily workflows: Security reminders, interactive sessions, and
              department-specific threat scenarios.
              <br />
              Real-world attack simulations: Regular phishing tests and cyber drills to reinforce
              practical awareness.
              <br />
              Executive sponsorship: Gaining leadership support to promote security as a business
              priority, not just an IT concern.
              <br />
              By aligning awareness programs with departmental functions and integrating security
              into everyday operations, organizations can build a resilient security-first culture.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You've built an exceptional career spanning across multiple prestigious banks and
                earned some of the highest certifications in the industry.
              </strong>
            </h5>
            <h5 className="text-white">
              What has been the most defining moment in your cybersecurity career so far?
              <br />
              Cybersecurity is an ever-evolving field, and my career has been shaped by continuous
              learning, strategic leadership, and industry recognition.
              <br />
              One of my most defining moments was being recognized with the World CIO 200 Summit -
              Egypt Award in the "Legends Category" for multiple years. This acknowledgement
              validated my efforts in driving security innovation, resilience, and leadership within
              the financial sector.
              <br />
              Additionally, leading the development and execution of comprehensive cybersecurity
              strategies for major banking institutions—ensuring regulatory compliance while
              mitigating advanced threats—has been a pivotal aspect of my journey.
              <br />
              More importantly, having the opportunity to mentor and guide the next generation of
              cybersecurity professionals has been personally rewarding. Empowering others to carry
              forward the mission of securing the digital world is perhaps the most impactful legacy
              of all.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
